// React
import { useState } from 'react';

// Custom components
import FieldNameRenderer from 'components/TemplatePreview/Fields/FieldNameRenderer';

// Utils
import { ChecklistItemType } from 'pages/TemplateDashboard/context';

// Styled
import { StyledTextField, UnitText, StyledInputAdornment } from './styled';
import FormulaDescription from 'components/common/jsxrender/checklistV2/builder/formulaDescription';

interface NumberPropTypes {
  item: ChecklistItemType;
  preview?: boolean;
  onChangeCb?: (value: number) => void;
  isEmulatorView?: boolean;
  checklistHash?: any;
}

const Calculation = ({
  item,
  preview = true,
  onChangeCb,
  isEmulatorView,
  checklistHash = null,
}: NumberPropTypes) => {
  const [value, setValue] = useState('');

  return (
    <FieldNameRenderer
      preview={preview}
      fieldName={item.description}
      item={item}
      isEmulatorView={isEmulatorView}
    >
      <StyledTextField
        isemulatorview={isEmulatorView ? 'true' : ''}
        disabled={true}
        value={value}
        sx={{ background: '#F5F5F5' }}
        type={'number'}
        size="small"
        InputProps={{
          endAdornment: !!item.unit && (
            <StyledInputAdornment position="end">
              <UnitText>{item.unit}</UnitText>
            </StyledInputAdornment>
          ),
        }}
      />
      {/* formula description1 */}
      {!isEmulatorView && checklistHash && (
        <>
          {checklistHash && (
            <FormulaDescription
              styles={{ marginTop: '10px' }}
              field={{ ...item }}
              checkListItems={checklistHash}
            />
          )}
        </>
      )}
    </FieldNameRenderer>
  );
};

export default Calculation;
